import { Translator } from 'lib/i18n';
import { MemberId, Member } from 'types';

export const orderMembers = (members: Array<Member>) =>
  members.sort((a: Member) => (a.isLoggedInUser !== true ? 1 : -1));

export const getLoggedInMember = (members: Array<Member>) =>
  members.find((m: Member) => m.isLoggedInUser);

export const getMemberRole = (member: Member, t: Translator) => {
  if (member.isMaster) {
    return t('home_hub.members.roles.plan_manager');
  } else if (member.isChildAccount) {
    return t('home_hub.members.roles.kids_accounts');
  }
  return t('home_hub.members.roles.plan_member');
};

export const getMemberById = (members: Array<Member>, id: MemberId) =>
  members.find((m: Member) => m.id === id);
